var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouterActionTypes } from '../actions/router.action.types';
import { FxpServiceFactory, FXPServiceCatalog } from '@fxp/fxpservices-di';
import { DefaultTransition } from '../common/models/transistion.model';
var NavigationReducerFactory = /** @class */ (function () {
    function NavigationReducerFactory(fxpRouteService, windowObj) {
        this._fxpRouteService = fxpRouteService;
        if (windowObj !== undefined && windowObj !== null) {
            this._window = windowObj;
        }
        else {
            this._window = window;
        }
    }
    NavigationReducerFactory.prototype.BuildNavigationReducer = function () {
        var _this = this;
        var navigationReducer = function (state, action) {
            if (state === void 0) { state = DefaultTransition; }
            switch (action.type) {
                case RouterActionTypes.NAVIGATE_TO_STATE: {
                    _this._fxpRouteService = _this.GetFxpRouter();
                    var payload = action.payload;
                    if (payload.OpenInNewWindow) {
                        _this._fxpRouteService.navigatetoNewWindow(payload.StateName);
                    }
                    else {
                        _this._fxpRouteService.navigatetoSpecificState(payload.StateName, payload.Params, payload.TransitionOptions);
                    }
                    return __assign({}, state, { ActionType: action.type, State: payload.StateName, Params: payload.Params });
                }
                case RouterActionTypes.NAVIGATE_TO_URL: {
                    _this._fxpRouteService = _this.GetFxpRouter();
                    var payload = action.payload;
                    _this._fxpRouteService.navigateToSpecificUrl(payload.URL, payload.Target, payload.Features, payload.Replace);
                    return __assign({}, state, { ActionType: action.type, State: payload.URL });
                }
                case RouterActionTypes.GO_BACK: {
                    if (_this._window && _this._window) {
                        _this._window.history.back();
                    }
                    return __assign({}, state, { ActionType: action.type });
                }
            }
            return state;
        };
        return navigationReducer;
    };
    NavigationReducerFactory.prototype.GetFxpRouter = function () {
        if (this._fxpRouteService === undefined || this._fxpRouteService === null) {
            try {
                return FxpServiceFactory.getServiceInstance(FXPServiceCatalog.FxpRouteService);
            }
            catch (error) {
                console.error("ERROR: There was an error while trying to get the FXP Router Service");
                console.error(error);
                return null;
            }
        }
        else {
            return this._fxpRouteService;
        }
    };
    return NavigationReducerFactory;
}());
export { NavigationReducerFactory };
//# sourceMappingURL=navigation.reducer.factory.js.map